import '@fortawesome/fontawesome-free/css/all.min.css';
export const MainNav = [
  {
    icon: "pe-7s-rocket",
    label: "Dashboards",
    content: [
      {
        label: "Analytics",
        to: "#/dashboards/analytics",
      },
      {
        label: "Commerce",
        to: "#/dashboards/commerce",
      },
      {
        label: "Sales",
        to: "#/dashboards/sales",
      },
      {
        label: "Minimal",
        content: [
          {
            label: "Variation 1",
            to: "#/dashboards/minimal-dashboard-1",
          },
          {
            label: "Variation 2",
            to: "#/dashboards/minimal-dashboard-2",
          },
        ],
      },
      {
        label: "CRM",
        to: "#/dashboards",
      },
    ],
  },
  {
    icon: "pe-7s-browser",
    label: "Pages",
    content: [
      {
        label: "Login",
        to: "#/pages/login",
      },
      {
        label: "Login Boxed",
        to: "#/pages/login-boxed",
      },
      {
        label: "Register",
        to: "#/pages/register",
      },
      {
        label: "Register Boxed",
        to: "#/pages/register-boxed",
      },
      {
        label: "Forgot Password",
        to: "#/pages/forgot-password",
      },
      {
        label: "Forgot Password Boxed",
        to: "#/pages/forgot-password-boxed",
      },
    ],
  },
  {
    icon: "pe-7s-plugin",
    label: "Applications",
    content: [
      {
        label: "Mailbox",
        to: "#/apps/mailbox",
      },
      {
        label: "Chat",
        to: "#/apps/chat",
      },
      {
        label: "FAQ Section",
        to: "#/apps/faq-section",
      },
    ],
  },
];
export const ComponentsNav = [
  {
    icon: "pe-7s-diamond",
    label: "Elements",
    content: [
      {
        label: "Buttons",
        content: [
          {
            label: "Standard",
            to: "#/elements/buttons-standard",
          },
          {
            label: "Pills",
            to: "#/elements/buttons-pills",
          },
          {
            label: "Square",
            to: "#/elements/buttons-square",
          },
          {
            label: "Shadow",
            to: "#/elements/buttons-shadow",
          },
          {
            label: "With Icons",
            to: "#/elements/buttons-icons",
          },
        ],
      },
      {
        label: "Dropdowns",
        to: "#/elements/dropdowns",
      },
      {
        label: "Icons",
        to: "#/elements/icons",
      },
      {
        label: "Badges",
        to: "#/elements/badges-labels",
      },
      {
        label: "Cards",
        to: "#/elements/cards",
      },
      {
        label: "Loading Indicators",
        to: "#/elements/loaders",
      },
      {
        label: "List Groups",
        to: "#/elements/list-group",
      },
      {
        label: "Navigation Menus",
        to: "#/elements/navigation",
      },
      {
        label: "Timeline",
        to: "#/elements/timelines",
      },
      {
        label: "Utilities",
        to: "#/elements/utilities",
      },
      {
        label: "Visibility Sensor",
        to: "#/elements/visibility-sensor",
      },
    ],
  },
  {
    icon: "pe-7s-car",
    label: "Components",
    content: [
      {
        label: "Tabs",
        to: "#/components/tabs",
      },
      {
        label: "Accordions",
        to: "#/components/accordions",
      },
      {
        label: "Notifications",
        to: "#/components/notifications",
      },
      {
        label: "Modals",
        to: "#/components/modals",
      },
      {
        label: "Loading Blockers",
        to: "#/components/loading-blocks",
      },
      {
        label: "Progress Bar",
        to: "#/components/progress-bar",
      },
      {
        label: "Tooltips & Popovers",
        to: "#/components/tooltips-popovers",
      },
      {
        label: "Carousel",
        to: "#/components/carousel",
      },
      {
        label: "Calendar",
        to: "#/components/calendar",
      },
      {
        label: "Pagination",
        to: "#/components/pagination",
      },
      {
        label: "Count Up",
        to: "#/components/count-up",
      },
      {
        label: "Sticky Elements",
        to: "#/components/sticky-elements",
      },
      {
        label: "Scrollable",
        to: "#/components/scrollable-elements",
      },
      {
        label: "Maps",
        to: "#/components/maps",
      },
      {
        label: "Ratings",
        to: "#/components/ratings",
      },
      {
        label: "Image Crop",
        to: "#/components/image-crop",
      },
      {
        label: "Guided Tours",
        to: "#/components/guided-tours",
      },
    ],
  },
  {
    icon: "pe-7s-display2",
    label: "Tables",
    content: [
      {
        label: "Data Tables",
        content: [
          {
            label: "Basic",
            to: "#/tables/data-tables",
          },
          {
            label: "Fixed Header",
            to: "#/tables/datatables-fixed-header",
          },
          {
            label: "Selectable Rows",
            to: "#/tables/datatables-selectable-rows",
          },
        ],
      },
      {
        label: "Regular Tables",
        to: "#/tables/regular-tables",
      },
    ],
  },
];
export const FormsNav = [
  {
    icon: "pe-7s-light",
    label: "Elements",
    content: [
      {
        label: "Controls",
        to: "#/forms/controls",
      },
      {
        label: "Layouts",
        to: "#/forms/layouts",
      },
      {
        label: "Validation",
        to: "#/forms/validation",
      },
      {
        label: "Wizards",
        content: [
          {
            label: "Variation 1",
            to: "#/forms/wizard-1",
          },
          {
            label: "Variation 2",
            to: "#/forms/wizard-2",
          },
          {
            label: "Variation 3",
            to: "#/forms/wizard-3",
          },
        ],
      },
      {
        label: "Sticky Form Headers",
        to: "#/forms/sticky-headers",
      },
    ],
  },
  {
    icon: "pe-7s-joy",
    label: "Widgets",
    content: [
      {
        label: "Datepicker",
        to: "#/forms/datepicker",
      },
      {
        label: "Range Slider",
        to: "#/forms/range-slider",
      },
      {
        label: "Input Selects",
        to: "#/forms/input-selects",
      },
      {
        label: "Toggle Switch",
        to: "#/forms/toggle-switch",
      },
      {
        label: "Dropdowns",
        to: "#/forms/dropdown",
      },
      {
        label: "WYSIWYG Editor",
        to: "#/forms/wysiwyg-editor",
      },
      {
        label: "Input Mask",
        to: "#/forms/input-mask",
      },
      {
        label: "Typeahead",
        to: "#/forms/typeahead",
      },
      {
        label: "Clipboard",
        to: "#/forms/clipboard",
      },
      {
        label: "Textarea Autosize",
        to: "#/forms/textarea-autosize",
      },
      {
        label: "Number Spinners",
        to: "#/forms/numberspinners",
      },
      {
        label: "Color Picker",
        to: "#/forms/color-picker",
      },
      {
        label: "Dropzone",
        to: "#/forms/dropzone",
      },
    ],
  },
];
export const WidgetsNav = [
  {
    icon: "pe-7s-graph2",
    label: "Chart Boxes",
    content: [
      {
        label: "Variation 1",
        to: "#/widgets/chart-boxes",
      },
      {
        label: "Variation 2",
        to: "#/widgets/chart-boxes-2",
      },
      {
        label: "Variation 3",
        to: "#/widgets/chart-boxes-3",
      },
    ],
  },
  {
    icon: "pe-7s-id",
    label: "Profile Boxes",
    to: "#/widgets/profile-boxes",
  },
  {
    icon: "pe-7s-display1",
    label: "Content Boxes",
    to: "#/widgets/content-boxes",
  },
];
export const ChartsNav = [
  {
    icon: "pe-7s-graph2",
    label: "ChartJS",
    to: "#/charts/chartjs",
  },
  {
    icon: "pe-7s-graph",
    label: "Apex Charts",
    to: "#/charts/apexcharts",
  },
  {
    icon: "pe-7s-gleam",
    label: "Gauges",
    to: "#/charts/gauges",
  },
  {
    icon: "pe-7s-graph1",
    label: "Chart Sparklines 1",
    to: "#/charts/sparklines-1",
  },
  {
    icon: "pe-7s-edit",
    label: "Chart Sparklines 2",
    to: "#/charts/sparklines-2",
  },
];

// export const PropertiesManagerNav = [
//   {
//     icon: "pe-7s-home", // Property
//     label: "Property",
//     to: "#/properties/property",
//   },
//   {
//     icon: "pe-7s-note2", // Requirement
//     label: "Requirement",
//     to: "#/properties/requirement",
//   },
//   {
//     icon: "pe-7s-map", // Project
//     label: "Project",
//     to: "#/properties/project",
//   },
//   {
//     icon: "pe-7s-tools", // Service
//     label: "Service",
//     to: "#/properties/service",
//   },
// ];

// export const VerificationRequestNav = [
//   {
//     icon: "pe-7s-check", // Property Verification
//     label: "Property Verification",
//     to: "#/verification/propertyverification",
//   },
//   {
//     icon: "pe-7s-check", // Project Verification
//     label: "Project Verification",
//     to: "#/verification/projectverification",
//   },
//   {
//     icon: "pe-7s-check", // Service Verification
//     label: "Service Verification",
//     to: "#/verification/serviceverification",
//   },
//   {
//     icon: "pe-7s-check", // Verify tag
//     label: "Verify tag",
//     to: "#/verification/verifytag",
//   },
// ];

// export const UsersNav = [
//   {
//     icon: "pe-7s-users", // App Users
//     label: "App Users",
//     to: "#/users/appusers",
//   },
//   {
//     icon: "pe-7s-cash", // Paid Subscriber
//     label: "Paid Subscriber",
//     to: "#/users/paidsubscriber",
//   },
//   {
//     icon: "pe-7s-note2", // Activity Log
//     label: "Activity Log",
//     to: "#/users/activitylog",
//   },
//   {
//     icon: "pe-7s-key", // Sub Admin
//     label: "Sub Admin",
//     to: "#/users/subadmin",
//   },
// ];

// export const MastersNav = [
//   {
//     icon: "pe-7s-star", // Amenities
//     label: "Amenities",
//     to: "#/masters/amenities",
//   },
//   {
//     icon: "pe-7s-settings", // Tenant Preference
//     label: "Tenant Preference",
//     to: "#/masters/tenantpreference",
//   },
//   {
//     icon: "pe-7s-paperclip", // Attachments In PG
//     label: "Attachments In PG",
//     to: "#/masters/attachmentsinpg",
//   },
//   {
//     icon: "pe-7s-photo", // Images Labels
//     label: "Images Labels",
//     to: "#/masters/imageslabels",
//   },
//   {
//     icon: "pe-7s-smile", // Greetings
//     label: "Greetings",
//     to: "#/masters/greetings",
//   },
//   {
//     icon: "pe-7s-map-marker", // Map Icons
//     label: "Map Icons",
//     to: "#/masters/mapicons",
//   },
//   {
//     icon: "pe-7s-box2", // Services Category
//     label: "Services Category",
//     to: "#/masters/servicescategory",
//   },
//   {
//     icon: "pe-7s-gift", // Packages
//     label: "Packages",
//     to: "#/masters/packages",
//   },
// ];

// export const SettingsNav = [
//   {
//     icon: "pe-7s-shield", // My Rights
//     label: "My Rights",
//     to: "#/settings/myrights",
//   },
//   {
//     icon: "pe-7s-note2", // Admin History
//     label: "Admin History",
//     to: "#/settings/adminhistory",
//   },
//   {
//     icon: "pe-7s-unlock", // Password Reset
//     label: "Password Reset",
//     to: "#/settings/passwordreset",
//   },
//   {
//     icon: "pe-7s-user", // Profile
//     label: "Profile",
//     to: "#/settings/profile",
//   },
//   {
//     icon: "pe-7s-power", // Logout
//     label: "Logout",
//     to: "#/settings/Logout",
//   },
// ];

// export const DashboardNav = [
//   {
//     icon: "pe-7s-graph", // Dashboard
//     label: "Dashboard",
//     to: "#/dashboards",
//   }
// ];

// export const AdvertisementManageNav = [
//   {
//     icon: "pe-7s-display1", // Advertisement Manage
//     label: "Advertisement Manage",
//     to: "#/advertisement/advertisementmanage",
//   }
// ];

// export const LandmarksNav = [
//   {
//     icon: "pe-7s-map-marker", // Landmarks
//     label: "Landmarks",
//     to: "#/landmarks/list",
//   }
// ];

// Font Awesome icon mappings
export const PropertiesManagerNav = [
  {
    icon: "fa fa-home", // Property
    label: "Property",
    to: "#/properties/property",
  },
  {
    icon: "fa fa-file-alt", // Requirement
    label: "Requirement",
    to: "#/properties/requirement",
  },
  {
    icon: "fa fa-project-diagram", // Project
    label: "Project",
    to: "#/properties/project",
  },
  {
    icon: "fa fa-tools", // Service
    label: "Service",
    to: "#/properties/service",
  },
];

export const VerificationRequestNav = [
  {
    icon: "fa fa-check-circle", // Property Verification
    label: "Property Photo",
    to: "#/verification/propertyverification",
  },
  {
    icon: "fa fa-check-circle", // Project Verification
    label: "Project Photo",
    to: "#/verification/projectverification",
  },
  {
    icon: "fa fa-check-circle", // Service Verification
    label: "Service Photo",
    to: "#/verification/serviceverification",
  },
  {
    icon: "fa fa-check-double", // Verify tag
    label: "Verify tag",
    to: "#/verification/verifytag",
  },
  {
    icon: "fa fa-check-double", // Project Verification
    label: "Project Verification",
    to: "#/properties/project",
  },
];

export const UsersNav = [
  {
    icon: "fa fa-users", // App Users
    label: "App Users",
    to: "#/users/appusers",
  },
  {
    icon: "fa fa-dollar-sign", // Paid Subscriber
    label: "Paid Subscriber",
    to: "#/users/paidsubscriber",
  },
  {
  icon: "fa fa-tasks",
  label: "Bulk Edit Subscription",
  to: "#/masters/bulk-edit-subscriptions/list",
},
  {
    icon: "fa fa-gift", // Packages
    label: "Packages",
    to: "#/masters/packages",
  },
  {
    icon: "fa fa-history", // Activity Log
    label: "Activity Log",
    to: "#/users/activitylog",
  },
  {
    icon: "fa fa-key", // Sub Admin
    label: "Sub Admin",
    to: "#/users/subadmin",
  },
];

export const MastersNav = [
  {
    icon: "fa fa-star", // Amenities
    label: "Amenities",
    to: "#/masters/amenities",
  },
  {
    icon: "fa fa-cogs", // Tenant Preference
    label: "Tenant Preference",
    to: "#/masters/tenantpreference",
  },
 {
  icon: "fa fa-layer-group",
  label: "States",
  to: "#/masters/states/list",
},
{
  icon: "fa fa-map-marker",
  label: "Districts",
  to: "#/masters/districts/list",
},

// {
//   icon: "fa fa-map-marker",
//   label: " Edit Bulk ",
//   to: "#/masters/bulk-edit-subscription",
// },
{
  icon: "fa fa-search",
  label: "Hot Searches",
  to: "#/masters/hot-searches/list",
},
{
  icon: "fa fa-file-invoice",
  label: "Invoices",
  to: "#/masters/invoices/list",
},
  {
    icon: "fa fa-paperclip", // Attachments In PG
    label: "Attachments In PG",
    to: "#/masters/attachmentsinpg",
  },
  {
    icon: "fa fa-images", // Images Labels
    label: "Images Labels",
    to: "#/masters/imageslabels",
  },
  {
    icon: "fa fa-smile", // Greetings
    label: "Greetings",
    to: "#/masters/greetings",
  },
  {
    icon: "fa fa-map-marker-alt", // Map Icons
    label: "Map Icons",
    to: "#/masters/mapicons",
  },
  {
    icon: "fa fa-box-open", // Services Category
    label: "Services Category",
    to: "#/masters/servicescategory",
  },
  {
    icon: "fa fa-file-alt", // Document Type
    label: "Document Types",
    to: "#/masters/documenttype",
  },
  {
    icon: "fa fa-map", // Area Master
    label: "Areas",
    to: "#/masters/areas",
  },
  
  {
    icon: "fa fa-sync-alt", // Updated status Master
    label: "Updated Status",
    to: "#/masters/updated-status",
  },
  
];

export const SettingsNav = [
  {
    icon: "fa fa-shield-alt", // My Rights
    label: "My Rights",
    to: "#/settings/myrights",
  },
  {
    icon: "fa fa-file-alt", // Admin History
    label: "Admin History",
    to: "#/settings/adminhistory",
  },
  {
    icon: "fa fa-unlock-alt", // Password Reset
    label: "Password Reset",
    to: "#/settings/passwordreset",
  },
  {
    icon: "fa fa-user-circle", // Profile
    label: "Profile",
    to: "#/settings/profile",
  },
  {
    icon: "fa fa-sign-out-alt", // Logout
    label: "Logout",
    to: "#/settings/logout",
  },
];

export const DashboardNav = [
  {
    icon: "fa fa-chart-line", // Dashboard
    label: "Dashboard",
    to: "#/dashboards",
  }
];

export const AdvertisementManageNav = [
  {
    icon: "fa fa-ad", // Advertisement Manage
    label: "Advertisement Manage",
    to: "#/advertisement/advertisementmanage",
  },
  {
    icon: "fa fa-ad", // Eliteads Manage
    label: "Elite Advertisement",
    to: "#/advertisement/eliteads",
  },
  {
    icon: "fa fa-images", // Banner Master
    label: "Banners",
    to: "#/masters/banners",
  }
];

export const LandmarksNav = [
  {
    icon: "fa fa-map-marker-alt", // Landmarks
    label: "Landmarks",
    to: "#/landmarks/list",
  }
];
